<template>
  <v-container>
    <v-row class="mt-8 mb-8">
      <v-col align="center">
        <h1 class="text-h3 font-weight-bold primary--text mb-4">
          Our Services
        </h1>
        <p class="text-h5 grey--text text--darken-1 font-weight-light">
          We specialize in new construction as well as remodeling. We are here to enhance the beauty of your home.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" lg="4" v-for="service in services" :key="service.name" align="center">
        <v-card
          light
          elevation="8"
          class="service-card"
          hover
        >
          <v-img
            :src="getAssetImg(service.img)"
            height="300"
            class="service-img"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-card-title class="justify-center text-h5 font-weight-bold primary--text py-4">
            {{ service.name }}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  components: {},
  name: "ServicesView",
  metaInfo: {
    title: 'Services',
  },
  data() {
    return {
      services: [
        {
          name: "Metal Framing",
          img: '/services/metalframe_qsloj9.webp'
        },
        {
          name: "Drywall Installation",
          img: '/services/drywall_acj5hb.webp'
        },
        {
          name: "Taping",
          img: '/services/taping_wru2hs.webp'
        },
        {
          name: "Smooth Finish",
          img: '/services/smooth-finish_higkk4.webp'
        },
        {
          name: "Orange Peel Finish",
          img: '/services/orange_ntsuop.webp'
        },
        {
          name: "Skim Coat",
          img: '/services/skim_jtwrry.webp'
        },
        {
          name: "Various Types of Textures",
          img: '/services/texture_g45bq7.webp'
        },
        {
          name: "Popcorn Ceiling Removal",
          img: '/services/popcorn-ceiling_grzt2k.webp'
        },
        {
          name: "Patchings",
          img: '/services/patching_dhmhoz.webp'
        },
      ]
    }
  },
};
</script>

<style scoped>
.service-card {
  border-radius: 12px;
  transition: all 0.4s ease;
  overflow: hidden;
}

.service-card:hover {
  transform: translateY(-12px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2) !important;
}

.service-img {
  transition: all 0.4s ease;
}

.service-card:hover .service-img {
  transform: scale(1.05);
}
</style>
